import React from 'react';
import { parseJSON, pretty } from './activity';
export default function PromptContent({ diagnostic }) {
  if (diagnostic?.path === '/v1/messages/count_tokens')
    return (
      <div className='trace-empty'>
        计数请求仅记录大小与估算，不重复保存 Prompt
        正文。请查看对应的模型调用记录。
      </div>
    );
  if (!diagnostic?.bodies_enabled)
    return (
      <div className='trace-empty'>
        该请求未保存 Prompt
        正文。开启记录前的历史内容无法恢复；请查看开启后的新请求。
      </div>
    );
  const body = parseJSON(diagnostic.request_body);
  if (!body || typeof body !== 'object')
    return (
      <div className='trace-empty'>
        {typeof body === 'string' ? body : '没有保存 Prompt 内容'}
      </div>
    );
  const sections = [];
  if (body.system) sections.push({ name: 'System', value: body.system });
  for (const [index, message] of (Array.isArray(body.messages)
    ? body.messages
    : []
  ).entries())
    sections.push({
      name: `${index + 1} · ${message?.role || 'message'}`,
      value: message?.content ?? message,
    });
  if (body.messages && !Array.isArray(body.messages))
    sections.push({ name: 'Messages', value: body.messages });
  if (body.tools && (!Array.isArray(body.tools) || body.tools.length))
    sections.push({ name: 'Tools', value: body.tools });
  if (body.input !== undefined)
    sections.push({ name: 'Embedding Input', value: body.input });
  return (
    <div className='trace-prompt'>
      <p className='trace-muted'>
        已保存的原始请求上下文（脱敏）。平台后加的系统提示不包含在此视图。
      </p>
      {sections.length ? (
        sections.map((section, index) => (
          <section key={index}>
            <h3>{section.name}</h3>
            <pre className='trace-json'>{pretty(section.value)}</pre>
          </section>
        ))
      ) : (
        <p>该请求没有消息上下文。</p>
      )}
    </div>
  );
}
